import Box from "@mui/material/Box";
import type { TextFieldProps } from "@mui/material/TextField";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

interface RegisterFullNameTextFieldType
  extends Omit<TextFieldProps, "helperText"> {
  minFirstNameError: boolean;
  minTwoNameError: boolean;
  minThereNameError: boolean;
}

export default function RegisterFullNameTextField({
  minFirstNameError,
  minTwoNameError,
  minThereNameError,
  ...props
}: RegisterFullNameTextFieldType): React.JSX.Element {
  const { t } = useTranslation();
  const isSuccess = !props.value ? "common.black" : "success.main";
  return (
    <TextField
      {...props}
      helperText={
        <>
          <Typography
            color={
              minFirstNameError || minTwoNameError || minThereNameError
                ? "error.main"
                : isSuccess
            }
            component="div"
            variant="caption"
          >
            {minFirstNameError || minTwoNameError || minThereNameError
              ? t("fullName.invalidName")
              : t("fullName.requirements")}
          </Typography>
          <Box component="ul" sx={{ m: "unset" }}>
            <Typography
              color={minFirstNameError ? "error.main" : isSuccess}
              component="li"
              variant="caption"
            >
              {t("fullName.firstName")}
            </Typography>
            <Typography
              color={minTwoNameError ? "error.main" : isSuccess}
              component="li"
              variant="caption"
            >
              {t("fullName.lastName")}
            </Typography>
            {minThereNameError ? (
              <Typography color="error.main" component="li" variant="caption">
                {t("fullName.otherNames")}
              </Typography>
            ) : null}
          </Box>
          {minFirstNameError || minTwoNameError || minThereNameError ? null : (
            <Typography color={isSuccess} component="div" variant="caption">
              {t("fullName.noAbbreviation")}
            </Typography>
          )}
        </>
      }
      variant="outlined"
    />
  );
}
